import { TFunction } from 'i18next';
import { ProductFieldSource } from '@/models/products.model';

export const getFieldSourceLabel = (t: TFunction, source?: ProductFieldSource | null): string | null => {
  if (!source) {
    return null;
  }

  return t(`field_source_${source}`);
};

export const withFieldSourceLabel = (t: TFunction, labelKey: string, source?: ProductFieldSource | null): string => {
  const sourceLabel = getFieldSourceLabel(t, source);

  return sourceLabel ? `${t(labelKey)} (${sourceLabel})` : t(labelKey);
};
